// extracted by mini-css-extract-plugin
export default {"error":"unlock-complete__error"};